export default class Joblist {
}
